export default () => {
	const products = document.querySelectorAll('.products');

	if (!products) return;

	products.forEach(item => {
			const categoryButtons = item.querySelectorAll('.category__button'),
				productList = item.querySelector('.products__list');

			categoryButtons.forEach(item => {
				item.addEventListener('click', () => {
					categoryButtons.forEach(item => {
						item.classList.remove('active');
					});
					productList.classList.add('loading');
					item.classList.add('active');
					const categoryID = item.getAttribute('data-category'),
						url = themeVars.ajaxurl,
						bodyData = {
							action: 'action=product_category_filter',
							nonce: '&nonce_code=' + themeVars.nonce,
							category: '&category_id=' + categoryID,
						};

					fetch(url, {
						method: "post",
						headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
						body: bodyData.action + bodyData.nonce + bodyData.category,
					})
						.then((response) => response.text())
						.then((result) => {
							if (result) {
								productList.innerHTML = "";
								productList.innerHTML = result;
								productList.classList.remove('loading');
							}
						})
						.catch((error) => {
							console.error(error);
						});
				});
			})
		})
}



// WEBPACK FOOTER //
// ./scripts/modules/category-filter.js